import {
  Box,
  Button,
  createStyles,
  IconButton,
  Modal,
  Paper,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Theme,
  Typography,
} from "@material-ui/core";
import {Pagination} from "@material-ui/lab";
import {makeStyles, withStyles} from "@material-ui/styles";
import LOADING from "assets/img/loading.gif";

import managerLessonApi from "api/managerLesson";
import {useAppDispatch, useAppSelector} from "app/hooks";
import BACKGROUND from "assets/img/bg_manager_lesson.png";
import {useConfirm} from "material-ui-confirm";
import CloseIcon from "@material-ui/icons/Close";

import {ResponseStatus} from "models/common";
import React, {useState} from "react";
import {toast} from "react-toastify";
import {Lesson} from "models/managerLesson";

import {
  fetchLessonList,
  selectFilterLessonListFuture,
  selectLessonList,
  setFilterLessonListFuture,
} from "../../managerLessonSlice";
import EditCalendar from "../EditCalendar/EditCalendar";
import {useNavigate} from "react-router-dom";
import {useTranslation} from "react-i18next";

export interface ListLessonFutureProps {}

export default function ListLessonFuture(props: ListLessonFutureProps) {
  const useStyles = makeStyles((theme: Theme) => ({
    background: {
      backgroundImage: `url(${BACKGROUND})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      height: 100,
      width: "100%",
      [theme.breakpoints.up("xl")]: {
        width: "90%",
        height: 150,
      },
    },

    thumbnail_video: {
      width: 40,
      height: 40,
      objectFit: "cover",
    },

    percentHide: {
      width: "100%",
      position: "relative",
      backgroundColor: "#EFEFEF",
      height: 8,
      borderRadius: 8,
      marginTop: 5,
    },
    percent: {
      height: 8,
      borderRadius: 8,
      position: "absolute",
      top: 0,
      left: 0,
    },
    percentView: {
      backgroundColor: "#F1A34D",
    },
    percentLike: {
      backgroundColor: "  #0499C8",
    },
    percentComment: {
      backgroundColor: "  #04C8BC",
    },
    btn_delete: {
      borderRadius: 10,
      fontSize: 13,
      color: "#fff",
      padding: "5px 12px",
      background: "linear-gradient(0deg, #FD5468 0%, rgba(255, 193, 200, 0.9) 169.32%)",
    },
    btn_changeCalendar: {
      background: "linear-gradient(0deg, #10BCA7 0%, rgba(255, 239, 156, 0.9) 165.52%)",
      borderRadius: 10,
      fontSize: 13,
      color: "#fff",
      padding: "5px 12px",
      marginRight: 10,
    },

    btn_edit: {
      background: "linear-gradient(360deg, #019ABB 0%, rgba(167, 255, 255, 0.9) 168.18%)",
      borderRadius: 10,
      fontSize: 13,
      color: "#fff",
      padding: "5px 12px",
      marginRight: 10,
    },
    root_modal: {
      width: "100%",
      height: "70%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    modal__container: {
      width: "100%",
      maxWidth: 560,
      borderRadius: 12,
      backgroundColor: "#fff",
      zIndex: 9,
      display: "flex",
      flexDirection: "column",
      // margin: "30px 0",
    },
    modal__header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      padding: "0 24px",
      minHeight: 65,
      borderBottom: "1px solid rgb(235, 235, 235)",
      "& >h6": {
        fontWeight: 700,
        fontSize: 18,
        marginLeft: 50,
      },
    },
    container: {
      maxHeight: 500,
    },
  }));
  const StyledTableCell = withStyles((theme: Theme) =>
    createStyles({
      head: {
        padding: "16px 5px",
        // backgroundColor: "#F3F3F3CC",
        color: "#1B1B1B",
        fontSize: 11,
        fontWeight: 700,
        borderRight: "1px solid rgba(224, 224, 224, 1)",
        borderBottom: "1px solid #777777",
        [theme.breakpoints.up("xl")]: {
          fontSize: 13,
        },
      },
      body: {
        padding: "16px 5px",
        fontSize: 11,
        borderRight: "1px solid rgba(224, 224, 224, 1)",
        [theme.breakpoints.up("xl")]: {
          fontSize: 13,
        },
      },
    })
  )(TableCell);
  const {t} = useTranslation();
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [openModal, setOpenModal] = useState(false);
  const [currentLesson, setCurrentLesson] = useState<Lesson | undefined>();
  const listLesson = useAppSelector(selectLessonList);
  const filter = useAppSelector(selectFilterLessonListFuture);

  const confirm = useConfirm();
  const handleClose = () => {
    setOpenModal(false);
  };

  const handleChangePage = (page: number) => {
    dispatch(
      setFilterLessonListFuture({
        ...filter,
        page: page - 1,
      })
    );
  };
  const handleDeleteLesson = async (lesson: Lesson) => {
    confirm({
      title: (
        <Typography variant="h5" color="secondary">
          {t("delete.chuy")}
        </Typography>
      ),
      description: (
        <Typography variant="subtitle2">
          {t("delete.khiban")}{" "}
          <Typography variant="subtitle2" component="span" color="secondary">
            {t("delete.dongy")}
          </Typography>{" "}
          {t("delete.xoa")}
          <Typography variant="subtitle2" component="span" style={{color: "#004673"}}>
            {" "}
            {lesson.lessionName}
          </Typography>{" "}
          {t("delete.sexoatatcadulieu")}
        </Typography>
      ),
      confirmationText: <Button className={classes.btn_delete}> {t("delete.dongy")}</Button>,
      cancellationText: (
        <Button className={classes.btn_edit} style={{marginRight: 0}}>
          {t("delete.huybo")}
        </Button>
      ),
    })
      .then(async () => {
        const res: ResponseStatus = await managerLessonApi.deleteLesson(lesson.id);
        if (res.responseCode === "00") {
          toast.success(`${t("managerLesson.xoabaihocthanhcong")}`);
          dispatch(fetchLessonList({...filter, type: "FUTURE"}));
        } else {
          toast.error(`${t("managerLesson.xoabaihocthatbai")}`);
          throw new Error(res.responseDescription);
        }
      })
      .catch((error) => console.log(error));
  };
  return (
    <>
      <TableContainer component={Paper} className={classes.container}>
        <Table stickyHeader style={{minWidth: "1800px"}}>
          <TableHead>
            <TableRow>
              <StyledTableCell align="center" width="50px">
                {t("stt")}
              </StyledTableCell>
              <StyledTableCell align="center" width="100px">
                {t("managerLesson.video")}
              </StyledTableCell>
              <StyledTableCell align="center" width="200px">
                {t("managerLesson.tenbaihoc")}
              </StyledTableCell>
              <StyledTableCell align="center" width="120px">
                {t("managerLesson.ngaylenlich")}
              </StyledTableCell>
              <StyledTableCell align="center" width="120px">
                {t("managerLesson.ngayan")}
              </StyledTableCell>
              <StyledTableCell align="center" width="120px">
                {t("managerLesson.gioan")}
              </StyledTableCell>
              <StyledTableCell align="center" width="150px">
                {t("managerLesson.nguoilenlich")}
              </StyledTableCell>
              <StyledTableCell align="center" width="120px">
                {t("managerLesson.khuvuc")}
              </StyledTableCell>
              <StyledTableCell align="center" width="120px">
                {t("managerLesson.tinh")}
              </StyledTableCell>
              <StyledTableCell align="center" width="120px">
                {t("managerLesson.bophan")}
              </StyledTableCell>
              <StyledTableCell align="center" width="120px">
                {t("managerLesson.phongban")}
              </StyledTableCell>
              <StyledTableCell align="center" width="100px">
                {t("managerLesson.trai")}
              </StyledTableCell>
              <StyledTableCell align="center" width="400px">
                {t("thaotac")}
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {listLesson?.content.map((lesson: Lesson, index) => (
              <TableRow key={lesson.id}>
                <StyledTableCell align="center" component="th" scope="user">
                  {listLesson.size * listLesson.number + index + 1}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {lesson.attachment.urlThumbnail ? (
                    <img
                      src={lesson.attachment.urlThumbnail}
                      alt="thumbnal_video"
                      className={classes.thumbnail_video}
                    />
                  ) : (
                    <img src={LOADING} alt="thumbnal_video" className={classes.thumbnail_video} />
                  )}
                </StyledTableCell>
                <StyledTableCell align="center">{lesson.lessionName}</StyledTableCell>
                <StyledTableCell align="center">
                  {String(lesson?.publishDate).slice(-2)}/{String(lesson?.publishDate).slice(4, 6)}/
                  {String(lesson?.publishDate).slice(0, 4)}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {String(lesson?.expiryDateTimeAsString).slice(8)}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {String(lesson?.expiryDateTimeAsString).slice(0, 5)}
                </StyledTableCell>
                <StyledTableCell align="center">{lesson?.user?.name}</StyledTableCell>
                <StyledTableCell align="center">{lesson?.area?.name}</StyledTableCell>
                <StyledTableCell align="center">{lesson?.newProvince?.name}</StyledTableCell>
                <StyledTableCell align="center">{lesson?.department?.title}</StyledTableCell>
                <StyledTableCell align="center">{lesson?.workType?.name}</StyledTableCell>
                <StyledTableCell align="center">{lesson?.farm?.name}</StyledTableCell>
                <StyledTableCell align="center">
                  <Button
                    onClick={() =>
                      navigate(`/admin/manager-lesson/edit/future/${lesson.id}`, {
                        state: {
                          detailLesson: lesson,
                          type: "FUTURE",
                        },
                      })
                    }
                    className={classes.btn_edit}
                    size="small"
                  >
                    Chỉnh sửa
                  </Button>
                  <Button
                    onClick={() => {
                      setOpenModal(true);
                      setCurrentLesson(lesson);
                    }}
                    className={classes.btn_changeCalendar}
                    size="small"
                  >
                    {t("managerLesson.doilich")}
                  </Button>
                  <Button
                    onClick={() => handleDeleteLesson(lesson)}
                    className={classes.btn_delete}
                    size="small"
                  >
                    {t("managerLesson.xoabai")}
                  </Button>
                </StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      {listLesson?.totalPages > 1 && (
        <Box mt={3} display="flex" justifyContent="space-between">
          <Typography variant="subtitle2" style={{fontWeight: 600}}>
            {t("managerLesson.tongbaihoc")}: {listLesson.totalElements}
          </Typography>
          <Pagination
            count={Math.ceil(listLesson?.totalElements / listLesson?.size)}
            page={listLesson?.number + 1}
            variant="outlined"
            color="primary"
            shape="rounded"
            onChange={(e, page) => handleChangePage(page)}
          />
        </Box>
      )}

      <Modal
        open={openModal}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        closeAfterTransition
        className={classes.root_modal}
      >
        <Slide direction="up" in={openModal}>
          <Box className={classes.modal__container}>
            <Box className={classes.modal__header}>
              <div></div>
              <Typography variant="subtitle2"> {t("managerLesson.lichdang")}</Typography>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
            <EditCalendar lesson={currentLesson} setOpenModal={setOpenModal} type="FUTURE" />
          </Box>
        </Slide>
      </Modal>
    </>
  );
}
